/**
 * Lottie animation components for CanDo Payments.
 * Used for: success states, loading states.
 * Only used where animation genuinely enhances UX.
 */
import Lottie from "lottie-react";

// Minimal success checkmark animation — green circle with white tick
const successData = {
  v: "5.7.1", fr: 30, ip: 0, op: 40, w: 200, h: 200,
  layers: [{
    ty: 4, nm: "circle", ip: 0, op: 40, st: 0,
    ks: { o: { a: 1, k: [{ t: 0, s: [0] }, { t: 10, s: [100] }] }, r: { a: 0, k: 0 }, p: { a: 0, k: [100, 100] }, a: { a: 0, k: [0, 0] }, s: { a: 1, k: [{ t: 0, s: [0, 0] }, { t: 12, s: [110, 110] }, { t: 16, s: [100, 100] }] } },
    shapes: [{ ty: "el", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [120, 120] } }, { ty: "fl", c: { a: 0, k: [0.41, 0.75, 0.67, 1] } }]
  }, {
    ty: 4, nm: "tick", ip: 10, op: 40, st: 0,
    ks: { o: { a: 1, k: [{ t: 10, s: [0] }, { t: 16, s: [100] }] }, r: { a: 0, k: 0 }, p: { a: 0, k: [100, 100] }, a: { a: 0, k: [0, 0] }, s: { a: 0, k: [100, 100] } },
    shapes: [{ ty: "sh", ks: { a: 0, k: { c: false, v: [[-20, 0], [-6, 14], [22, -14]], i: [[0, 0], [0, 0], [0, 0]], o: [[0, 0], [0, 0], [0, 0]] } } }, { ty: "st", c: { a: 0, k: [1, 1, 1, 1] }, w: { a: 0, k: 6 }, lc: 2, lj: 2 }, { ty: "tm", s: { a: 0, k: 0 }, e: { a: 1, k: [{ t: 12, s: [0] }, { t: 22, s: [100] }] } }]
  }]
};

// Minimal loading dots animation
const loadingData = {
  v: "5.7.1", fr: 30, ip: 0, op: 60, w: 120, h: 40,
  layers: [0, 1, 2].map((i) => ({
    ty: 4, nm: `dot${i}`, ip: 0, op: 60, st: 0,
    ks: { o: { a: 1, k: [{ t: i * 6, s: [30] }, { t: i * 6 + 10, s: [100] }, { t: i * 6 + 20, s: [30] }] }, r: { a: 0, k: 0 }, p: { a: 0, k: [25 + i * 35, 20] }, a: { a: 0, k: [0, 0] }, s: { a: 1, k: [{ t: i * 6, s: [80, 80] }, { t: i * 6 + 10, s: [120, 120] }, { t: i * 6 + 20, s: [80, 80] }] } },
    shapes: [{ ty: "el", p: { a: 0, k: [0, 0] }, s: { a: 0, k: [16, 16] } }, { ty: "fl", c: { a: 0, k: [0.41, 0.75, 0.67, 1] } }]
  }))
};

export function LottieSuccess({ size = 80, className = "" }) {
  return (
    <div className={`inline-block ${className}`} style={{ width: size, height: size }} data-testid="lottie-success">
      <Lottie animationData={successData} loop={false} autoplay style={{ width: "100%", height: "100%" }} />
    </div>
  );
}

export function LottieLoading({ size = 60, className = "" }) {
  return (
    <div className={`inline-block ${className}`} style={{ width: size, height: size }} data-testid="lottie-loading">
      <Lottie animationData={loadingData} loop autoplay style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
